import React from 'react';
import 'twin.macro';
import HtmlViewer from 'components/HtmlViewer';
import { ROItemList } from 'components/ROItemList';
import { Label } from 'components/ROItemList/Label';
import { OldCustomField } from 'types/oldCustomField';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import { isDefined } from 'types/utils';

type Props = {
  customField: OldCustomField;
  /** Used to display multi-tags labels - they won't be displayed unless definition is passed */
  customFieldDefinition: CustomFieldDefinitionWithTargets | undefined;
};

export function PreviewCustomField({
  customField,
  customFieldDefinition,
}: Props) {
  switch (customField.type) {
    case 'text':
      return (
        <>
          <Label children={customField.singularName} />
          <HtmlViewer onChange={() => {}} text={customField.value as string} />
        </>
      );
    case 'multiselect':
      return (
        <ROItemList
          items={customField.items?.map(i => i.value) ?? []}
          label={customField.singularName ?? ''}
          labelPlural={customField.pluralName ?? ''}
          key={customField.id}
        />
      );
    case 'multitag': {
      const items =
        (customField.value as string[])
          ?.map(
            optionId =>
              customFieldDefinition?.options.find(
                option => option.id === optionId,
              )?.value,
          )
          .filter(isDefined) ?? [];
      return (
        <ROItemList
          items={items}
          label={customField.singularName ?? ''}
          labelPlural={customField.pluralName ?? ''}
          key={customField.id}
        />
      );
    }
  }
}

type ListProps = {
  customFields: OldCustomField[];
  /** Used to display multi-tags labels - they won't be displayed unless definition is passed */
  customFieldDefinitions: CustomFieldDefinitionWithTargets[] | undefined;
};

export function PreviewCustomFieldList({
  customFields,
  customFieldDefinitions,
}: ListProps) {
  return (
    <div tw="flex flex-col gap-2">
      {customFields.map(customField => (
        <div tw="flex flex-col" key={customField.id}>
          <PreviewCustomField
            customField={customField}
            customFieldDefinition={customFieldDefinitions?.find(
              definition => definition.id === customField.id,
            )}
          />
        </div>
      ))}
    </div>
  );
}
